<template>
    <div v-if="props.product?.typez === 'cat'" style="height: 56px !important" class="pt-24 left-0 text-midnight-800 hb20">
        {{ props.product.name }}
    </div>
    <template v-else-if="grid">
        <div class="d-flex flex-column gap-8 justify-content-between" @click="handleProductView">
            <div class="position-relative d-flex flex-column align-items-center">
                <div v-if="outOfStock" class="out-of-stock-overlay" style="aspect-ratio: 4 / 5; width: 100%; height: 100%">
                    <div v-if="image" class="border-rounded-5" style="background-position: center; background-size: cover; width: 100%; height: 100%" :style="{ backgroundImage: `url(${imageUrl})` }"/>
                    <div v-else class="d-flex align-items-center justify-content-center bg-midnight-200 border-rounded-5" style="width: 100%; height: 100%">
                        <Icon name="far fa-image" size="2x"/>
                    </div>
                    <div class="position-absolute border-rounded-5 tm14 text-midnight-800" style="z-index: 1; left: 50%; transform: translateX(-50%); bottom: 40px; padding: 2px 11px 2px 11px; background-color: white; box-shadow: 0 4px 4px rgba(49, 53, 91, 0.12);">
                        Sold out
                    </div>
                </div>
                <div v-else style="aspect-ratio: 4 / 5; width: 100%; height: 100%">
                    <div v-if="image" class="border-rounded-5" style="background-position: center; background-size: cover; width: 100%; height: 100%" :style="{ backgroundImage: `url(${imageUrl})` }"/>
                    <div v-else class="d-flex align-items-center justify-content-center bg-midnight-200 border-rounded-5" style="width: 100%; height: 100%">
                        <Icon name="far fa-image" size="2x"/>
                    </div>
                    <div v-if="!product.productOptions.length && !product.buyGetPromotion.enabled" class="position-absolute" style="bottom: 0.5rem; right: 0.5rem" @click.stop>
                        <ProductStepper :product="props.product" style="cursor: pointer"/>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column justify-content-between" style="flex: 1 1 auto">
                <div class="d-flex flex-column gap-8">
                    <span class="text-midnight-800 tm16 line-clamp-1" style="text-overflow: ellipsis; width: 184px !important;">
                        {{ props.product.name }}
                    </span>
                </div>
                <div class="d-flex flex-column gap-4">
                    <div v-if="props.product.salePrice < props.product.price" class="d-flex gap-8">
                        <span class="text-midnight-700 tm16" style="text-decoration: line-through">${{ props.product.price.toFixed(2) }}</span>
                        <span class="tb16 text-peach-600">${{ props.product.salePrice.toFixed(2) }}</span>
                    </div>
                    <span v-else class="text-midnight-800 tb16">${{ props.product.price.toFixed(2) }}</span>
                    <div v-if="props.product.buyGetPromotion.enabled">
                        <Badge
                            :text="buildBogoCatchPhrase(props.product.buyGetPromotion)"
                            :variant="brandColor"/>
                    </div>
                </div>
            </div>
        </div>
    </template>
    <template v-else>
        <div style="height: 183px !important" class="d-flex gap-24 justify-content-between py-24 neutral-100-border-bottom" @click="handleProductView">
            <div class="d-flex flex-column justify-content-between" style="flex: 1 1 auto">
                <div class="d-flex flex-column gap-8">
                    <span class="product-list-item__name text-midnight-800 tm16" v-text="props.product.name"/>
                    <!-- eslint-disable-next-line vue/no-v-html -->
                    <span class="product-list-item__desc text-midnight-700 tr14" v-html="props.product.description"/>
                </div>
                <div class="d-flex flex-column gap-4">
                    <div v-if="props.product.salePrice < props.product.price" class="d-flex gap-8">
                        <span class="text-midnight-700 tm16" style="text-decoration: line-through">${{ props.product.price.toFixed(2) }}</span>
                        <span class="tb16 text-peach-600">${{ props.product.salePrice.toFixed(2) }}</span>
                    </div>
                    <span v-else class="text-midnight-800 tb16">${{ props.product.price.toFixed(2) }}</span>
                    <div v-if="props.product.buyGetPromotion.enabled">
                        <Badge
                            :text="buildBogoCatchPhrase(props.product.buyGetPromotion)"
                            :variant="brandColor"/>
                    </div>
                </div>
            </div>
            <template v-if="outOfStock">
                <div class="position-relative" style="height: 134px; width: 134px; min-width: 134px; min-height: 134px">
                    <div v-if="image && imageUrl" class="out-of-stock-overlay border-rounded-5 overflow-hidden" style="min-height: 134px; min-width: 134px; height: 134px; width: 134px">
                        <img :src="imageUrl" :alt="primaryImage.caption" width="134" height="134">
                    </div>
                    <div v-else class="out-of-stock-overlay d-flex align-items-center justify-content-center bg-midnight-200 border-rounded-5" style="min-width: 134px; min-height: 134px; width: 134px; height: 134px">
                        <Icon name="far fa-image" size="2x"/>
                    </div>
                    <div class="position-absolute border-rounded-5 tm14 text-midnight-800" style="white-space: nowrap; left: 50%; transform: translateX(-50%); bottom: 1rem; padding: 2px 11px 2px 11px; background-color: white; box-shadow: 0 4px 4px rgba(49, 53, 91, 0.12);">
                        Sold out
                    </div>
                </div>
            </template>
            <div v-else class="position-relative" style="height: 134px; width: 134px; min-width: 134px; min-height: 134px">
                <img v-if="image && imageUrl" class="border-rounded-5" :src="imageUrl" :alt="primaryImage.caption" width="134" height="134">
                <div v-else class="d-flex align-items-center justify-content-center bg-midnight-200 border-rounded-5" style="min-width: 134px; min-height: 134px; width: 134px; height: 134px">
                    <Icon name="far fa-image" size="2x"/>
                </div>
                <div v-if="!product.productOptions.length && !product.buyGetPromotion.enabled" class="position-absolute" style="bottom: 0.5rem; right: 0.5rem" @click.stop>
                    <ProductStepper :product="product" style="cursor: pointer"/>
                </div>
            </div>
        </div>
    </template>
</template>
<script setup lang="ts">
import {computed} from 'vue';
import {Badge, Icon} from '@helcim/blizzard';
import {useSettings} from '../../compositions';
import ProductStepper from './ProductStepper.vue';
import {cloudFileNameFormatted} from '../../models/utilities/ModelUtilities';
import Product from '../../store/classes/Product';
import {buildBogoCatchPhrase, isOutOfStock} from '../../store/utilities';


const emit = defineEmits<{
    (event: 'click-product'): void
}>();

const props = withDefaults(defineProps<{
    product: Product & { typez: string, name: string },
    isStepperExpanded: boolean,
    grid?: boolean,
}>(), {
    grid: false,
});

const { brandColor } = useSettings();

const image = computed(() => !!props.product?.images?.length);
const primaryImage = computed(() => {
    if(!image.value) {
        return null;
    }
    return props.product.images.filter(v => v.primaryImage)[0] ?? props.product.images[0];
});
const imageUrl = computed(() => {
    if(!image.value) {
        return '';
    }
    return cloudFileNameFormatted(primaryImage.value.cloudFileName);
});

const handleProductView = () => {
    emit('click-product');
};

const { inventorySetting } = useSettings();

const outOfStock = computed(() => {
    return isOutOfStock(
        props.product,
        inventorySetting.value,
    );
});
</script>
<style lang="scss">
.out-of-stock-overlay::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 5px;
    background-color: #4C4C4C;
    opacity: .5;
}
.neutral-100-border-bottom {
    border-bottom: 2px solid #F1F0F6;
}
</style>